import { PROGRAM_IDS } from "@constants/programs";

export function getCertificateExternalString(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "External training course";
    case PROGRAM_IDS.NWAS_EPRR:
      return "External training";
    default:
      return "External training course";
  }
}

export function getCertificateInternalString(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Internal training verification";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Internal training";
    default:
      return "Internal training verification";
  }
}

export function getTrainerNameTitle(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Trainer name";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Facilitator name";
    default:
      return "Trainer name";
  }
}

export function getTrainerNamePlaceholder(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Add trainer name...";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Add facilitator name...";
    default:
      return "Add trainer name...";
  }
}

export function getVerificationDateTitle(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Issue date";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Certification date";
    default:
      return "Issue date";
  }
}

export function getVerificationEmailTitle(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Trainer’s email for verification";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Facilitator’s email address";
    default:
      return "Trainer’s email for verification";
  }
}

export function getVerificationEmailPlaceholder(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Add trainer email...";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Add facilitator email...";
    default:
      return "Add trainer email...";
  }
}

export function getCertificateSignOffFormTitle(programID: string): string {
  switch (programID) {
    case PROGRAM_IDS.NWAS_ARC:
      return "Competency Sign-off form (optional)";
    case PROGRAM_IDS.NWAS_EPRR:
      return "Certificate (optional)";
    default:
      return "Certificate (optional)";
  }
}
